import { isEmpty, isNil, values, omit, compose, any, map, propOr } from 'ramda';

type Data = { [key: string]: Record<string, unknown>[] };

export type DefaultError = {
  displayMessage: string;
  message: string;
};

const isNotValid = (data: any): boolean => isEmpty(data) || isNil(data);

const keyMapping = (queryKey: string) =>
  map((data: Data) => propOr(data, queryKey, data));

const dataMapping = (queryKey: string) =>
  compose(keyMapping(queryKey), values as any, omit(['__typename']));

const isInvalidData = (
  data: Record<string, unknown>[],
  queryKey: string,
): boolean => any(isNotValid, dataMapping(queryKey)(data));

const getDefaultReportError = (
  merchantName = '',
  reportName: string,
): DefaultError => ({
  displayMessage: `Something went wrong for ${merchantName}'s ${reportName} report.`,
  message: `We weren't able to run the ${reportName} report for the dates you provided. Please check the dates and run again.`,
});

export { isNotValid, isInvalidData, getDefaultReportError };
